export const loginApi = '/oshaApi/v1/users/login';
export const logoutApi = '/oshaApi/v1/users/logout';
export const samlLogoutApi = '/saml/logout';
export const createUserApi = '/oshaApi/v1/users';
export const DEBUG = '?XDEBUG_SESSION_START=netbeans-xdebug';
export const localURL = 'http://127.0.0.1:32770';
export const getFormsApi = '/oshaApi/v1/organizations/ita/forms';
export const establishmentApi = '/oshaApi/v1/establishments';
export const establishmentBulkRemovalApi = '/oshaApi/v1/establishments_bulkremoval';
export const passwordResetApi = '/oshaApi/v1/users/password_reset';
export const injurySummaryApi = '/oshaApi/v1/forms/form300A';
export const allInjurySummaryApi = '/oshaApi/v1/forms/allForm300A';
export const submissionApi = '/oshaApi/v1/submissions';
export const combinedSubmissionApi = '/oshaApi/v1/combinedSubmissions';
export const refreshTokenApi = '/oshaApi/v1/users/apiToken';
export const uploadFile = '/oshaApi/v1/files/submit';
export const uploadCaseDataFile = '/oshaApi/v1/files/case-data-submit';
export const statePlanApi = '/oshaApi/v1/ita/state_plan_states';
export const apiDocumentationFilePath = '/sites/default/files/ita/documentation/osha_injury-tracking-application-api-documentation-v1.pdf';
export const helpDeskApiPath = '/oshaApi/v1/ita/send_helpdesk_email';
export const naicsCodesApiPath = '/oshaApi/v1/custom/naics_search_api.php';
export const getEstablishmentUsersApi = '/oshaApi/v1/establishmentusers';
export const establishmentUserApi = '/oshaApi/v1/establishmentuser';
export const validateLoggedInUserApi = '/oshaApi/v1/users/login/validate';
export const validateEstablishmentUserApi = '/oshaApi/v1/user/validate';
export const caseDataApi = '/oshaApi/v1/forms/form300And301';
export const deleteCaseDataApi = '/oshaApi/v1/forms/form300And301';
export const allCaseDataApi = '/oshaApi/v1/forms/allForm300And301';
export const caseDataFormRequired = "/oshaApi/v1/custom/check_301_req.php";
export const summaryDataRequired = "/oshaApi/v1/custom/check_300a_req.php";
export const excludedStateApi = '/oshaApi/v1/ita/excluded_states';
export const queryEstablishmentsApi = '/oshaApi/v1/establishmentQuery';
export const transferEstablishmentsApi = '/oshaApi/v1/transferEstablishments';


/** WEBPACK FOOTER **
 ** ./src/constants/apiConstants.js
 **/